import { createContext } from 'react';
import type { ReaderOption, useStripeTerminalSession } from '@/hooks/useStripeTerminalSession';
import type { TerminalConfigurationResponse } from '@/services/revenue/functions';

type StripeTerminalSessionValue = Omit<
  ReturnType<typeof useStripeTerminalSession>,
  'disconnectReader'
>;

export type StripeTerminalContextValue = StripeTerminalSessionValue & {
  terminalConfig: TerminalConfigurationResponse | undefined;
  isConfigLoading: boolean;
  isConnecting: boolean;
  isReconnecting: boolean;
  reconnectFailed: boolean;
  connectDefaultReader: (options?: { resetAttempts?: boolean }) => Promise<ReaderOption | null>;
  disconnectDefaultReader: () => Promise<void>;
};

export const StripeTerminalContext = createContext<StripeTerminalContextValue | null>(null);
